import { render, staticRenderFns } from "./PromotionMaxCustomerUses.vue?vue&type=template&id=a54698fe&"
import script from "./PromotionMaxCustomerUses.vue?vue&type=script&lang=ts&"
export * from "./PromotionMaxCustomerUses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports